module.exports = __webpack_public_path__ + "resource/img/man.4544530.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/man.jpg
// module id = mdvi
// module chunks = 1